import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex--wrap flex--gap-extra-large" }
const _hoisted_2 = { class: "mb-8" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "checkbox-wrapper" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "checkbox__label" }
const _hoisted_7 = { class: "mb-8" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "checkbox-wrapper" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "checkbox__label" }
const _hoisted_12 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock($setup["SimpleModalComponent"], {
    heading: "Choose filters",
    onCloseModal: _cache[3] || (_cache[3] = $event => ($setup.emit( 'close-modal' )))
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.dropdown_filter_components, (filter, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: `dropdown-filter-${filter.value}`
            }, [
              (index < $setup.dropdown_filter_components.length / 2)
                ? (_openBlock(), _createElementBlock("li", _hoisted_3, [
                    _createElementVNode("label", _hoisted_4, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.selection) = $event)),
                        class: "checkbox",
                        type: "checkbox",
                        value: filter.value
                      }, null, 8 /* PROPS */, _hoisted_5), [
                        [_vModelCheckbox, $setup.selection]
                      ]),
                      _createElementVNode("span", _hoisted_6, _toDisplayString(filter.label), 1 /* TEXT */)
                    ])
                  ]))
                : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _createElementVNode("ul", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.dropdown_filter_components, (filter, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: `dropdown-filter-${filter.value}`
            }, [
              (index >= $setup.dropdown_filter_components.length / 2)
                ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                    _createElementVNode("label", _hoisted_9, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.selection) = $event)),
                        class: "checkbox",
                        type: "checkbox",
                        value: filter.value
                      }, null, 8 /* PROPS */, _hoisted_10), [
                        [_vModelCheckbox, $setup.selection]
                      ]),
                      _createElementVNode("span", _hoisted_11, _toDisplayString(filter.label), 1 /* TEXT */)
                    ])
                  ]))
                : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ])
    ]),
    buttons: _withCtx(() => [
      _createElementVNode("button", {
        class: "button",
        disabled: _ctx.loading,
        onClick: _cache[2] || (_cache[2] = $event => ($setup.emit( 'close-modal' )))
      }, " Cancel ", 8 /* PROPS */, _hoisted_12),
      _createElementVNode("button", {
        class: "button button--fill",
        onClick: $setup.setSelectedFilters
      }, " Save ")
    ]),
    _: 1 /* STABLE */
  }))
}